import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Clock = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Clock" {...props}>
    <path d="M12 6C12.5523 6 13 6.44772 13 7V11.5L16.5996 14.2002C17.0414 14.5315 17.131 15.1578 16.7998 15.5996C16.4685 16.0414 15.8422 16.131 15.4004 15.7998L11.4004 12.7998C11.1486 12.611 11 12.3148 11 12V7C11 6.44772 11.4477 6 12 6Z" fill="#000" /><path fillRule="evenodd" clipRule="evenodd" d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" fill="#000" />
  </StyledIcon>
));

Clock.displayName = 'Clock';

export { Clock };
